/*
 * Howdy 会員登録フォーム（/tools/howdy-apps/register および埋め込みブロック）の補強。
 * アプリ側は素の POST 送信で、送信中の表示も郵便番号からの住所補完も動かないため
 * テーマ側から足す。フォームが無いページでは即座に何もせず抜ける。
 */
(function () {
  var form = document.querySelector('form.hrf-form');
  if (!form) return;

  /* ─── 送信中の表示・二重送信の防止 ─── */
  // 素の POST 送信＝ページが切り替わるまでアプリのサーバー応答を待つ（実測 約6秒）。
  // その間ボタンが押せたままだと二重に送信できてしまう。
  var submitBtn = form.querySelector('.hrf-submit, .btn-submit');

  if (submitBtn) {
    form.addEventListener('submit', function () {
      // 入力チェックで止まった場合は submit 自体が発火しないため、押せないままにはならない。
      // 見た目はその場で切り替える（クラス側で pointer-events を切って連打を止める）。
      submitBtn.classList.add('hrf-submit--loading');
      // disabled は送信が始まってから付ける。Safari には submit ハンドラ内で同期的に
      // 無効化すると送信自体を取りこぼす既知の癖があるため、1 tick 遅らせる。
      setTimeout(function () {
        submitBtn.disabled = true;
      }, 0);
    });

    // 戻るボタンで復帰したときにボタンが無効のままにならないようにする
    window.addEventListener('pageshow', function () {
      submitBtn.classList.remove('hrf-submit--loading');
      submitBtn.disabled = false;
    });
  }

  /* ─── 郵便番号 → 住所 ─── */
  // YubinBango 本体はアプリが読み込んでおり、各欄の目印（p-postal-code 等）も付いているが、
  // 自動初期化は使えない。ライブラリが n / e / t という共有の名前を使っており、
  // 同じページの別スクリプト（lenis ほか）に後から上書きされて初期化時にエラーになるため。
  // 名前の取り合いに巻き込まれない YubinBango.Core を直接呼ぶ。
  var zipFields = form.querySelectorAll('.p-postal-code');
  if (!zipFields.length) return;

  // 住所欄の目印 → YubinBango が返すキー
  var TARGETS = [
    ['.p-region', 'region'],
    ['.p-locality', 'l'],
    ['.p-street-address', 'm'],
    ['.p-extended-address', 'o'],
  ];

  var lastLookup = '';

  function fill(address) {
    TARGETS.forEach(function (target) {
      var field = form.querySelector(target[0]);
      var value = address[target[1]];
      // 該当が無いキーは空で返る。空で上書きすると手入力を消すので触らない。
      if (!field || !value) return;
      field.value = value;
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function lookup() {
    if (!window.YubinBango || !window.YubinBango.Core) return;

    var digits = [].map
      .call(zipFields, function (field) {
        return field.value;
      })
      .join('')
      .replace(/[０-９]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 65248);
      })
      .replace(/[^0-9]/g, '');

    // 7桁揃ったときだけ引く。入力途中の桁で手入力済みの住所を消さないため。
    if (digits.length !== 7 || digits === lastLookup) return;
    lastLookup = digits;
    new window.YubinBango.Core(digits, fill);
  }

  [].forEach.call(zipFields, function (field) {
    field.addEventListener('input', lookup);
    field.addEventListener('change', lookup);
  });
})();
